import { useRoutes, Outlet } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute"

import Create from "./Base/Create.js"
import View from "./Base/View.js"
import { Update } from "@mui/icons-material";

export default function FERoutes(props){
    const { getContext } = props;  // Access context from props
    
    // Define JSON paths for reuse
    let masterJson="vconfig/"+getContext+"/save.json";
    let viewTable="vconfig/"+getContext+"/view.json";
    let CarrierCardArray="vconfig/"+getContext+"/view.json";
    
    const routes = [
      // Handle the exact path pattern for /context/policy/view
      {
              path: ":context/:module/menu",
              element: <CreateCard cardJson={[...CarrierCardArray]} />
      },
      {
        path: ':context/:module/all',
        element: <View getContext={getContext} />,
      },
      {
        path: ':context/:module/',
        element: <View 
          getContext={getContext} 
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      },{
        path: ':context/:module/add',
        element: <Create 
          getContext={getContext} 
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      },{
        path: ':context/:module/new',
        element: <Create 
          getContext={getContext} 
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      },
      {
        path: ':context/:module/:id',
        element: <EditFormRoute 
          getContext={getContext} 
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      },{
        path: ':module',
        element: <View
          getContext={getContext}
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      },{
        path: ':module/add',
        element: <Create
          getContext={getContext}
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      },{
        path: ':module/new',
        element: <Create
          getContext={getContext}
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      },{
        path: ':module/all',
        element: <View
          getContext={getContext}
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      },{
        path: '/:module/:id',
        element: <Create
          getContext={getContext} 
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      },
      // Default case for the root path
      {
        index: true,
        element: <Create
          getContext={getContext}
          masterJsonPath={masterJson}
          viewTablePath={viewTable}
        />,
      }, 
      // Catch-all for 404s
      {
        path: '*',
        element: <div>Not Found - URL not recognized</div>,
      },
    ];
    
    return useRoutes(routes);
};